import { user } from 'larasnap';
import Echo from './assets/js/classes/echo/Echo';

export let socketId;

export const listen = (event, ...args) => {
    if (user) {
        const channel = `larasnap.user.${user.id}`;
        const instance = Echo.private(channel);
        instance.listen(event, ...args);

        return () => instance.stopListening(event);
    } else {
        return () => {};
    }
};

export const listenOnce = (event, handler) => {
    let stopListening;

    const newHandler = (...args) => {
        stopListening();
        handler(...args);
    };

    stopListening = listen(event, newHandler);
};

export const socketIdReady = new Promise(resolve => {
    const cooldown = 100;
    const maxAttempts = 20;
    let attempt = 0;

    const intervalId = setInterval(() => {
        socketId = Echo.socketId();
        if (socketId) {
            resolve(socketId);
        }

        if (socketId || attempt++ === maxAttempts) {
            clearInterval(intervalId);
        }
    }, cooldown);
});

export default Echo;
